// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-input-box-modal {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: lightgray;
  border-radius: 40px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  background: #fff;
  transition: all 0.3s ease;
}

.search-container-box-modal-new {
  flex: 1;
}

.new-search-dialog {
  background-color: white;
}

.dark .new-search-dialog {
  background-color: var(--dark-blue);
}

.recent-search-card {
  margin: 5px !important;
  border-radius: 20px !important;
  box-shadow:
    rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em,
    rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em,
    rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
  padding: 0.5rem;
  width: min-content;
  background-color: white;
  color: black !important;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border: none;
  max-width: 300px;
}

.dark .recent-search-card {
  background-color: var(--dark-blue);
  color: white !important;
}

.recent-search-card:hover {
  transform: scale(1.03);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  background-color: #92f3c0 !important;
  color: black !important;
  font-weight: 1000 !important;
}

.recent-search-title {
  font-size: 0.9rem !important;
  overflow-wrap: break-word;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.5s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold !important;
}

.recent-search-description {
  font-size: 0.8rem !important;
  font-weight: bold !important;
}

.recent-search-add {
  background-color: #0563fb !important;
  color: white !important;
  font-weight: bold !important;
}

.recent-search-card:focus {
  background-color: #92f3c0 !important;
  color: black !important;
  border: none;
  outline: none;
}

.recent-search-inner-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popular-search-box {
  height: 100vh !important;
}

.popular-search-head {
  font-size: 1.1rem !important;
  font-weight: bold !important;
  text-align: left;
  padding: 10px !important;
  color: #0563fb;
}

.popular-search-box .MuiCardContent-root {
  padding: 0 !important;
  display: flex;
  flex-wrap: wrap;
}

.products-store-code-display-box {
  background-color: white;
  padding: 10px;
}

.product-store-code {
  font-size: 1rem !important;
  font-weight: bold !important;
  margin: 10px 0px 20px 0px !important;
}

.dark .products-store-code-display-box {
  background-color: var(--dark-blue);
}

.product-store-card {
  background-color: whitesmoke;
  padding: 1rem 1rem 0rem 1rem !important;
  display: flex;
  justify-content: space-between;
  box-shadow:
    rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px !important;
}

.dark .product-store-card {
  background-color: rgb(26, 29, 40);
  color: white;
}

.product-store-code-item {
  font-size: 1rem !important;
  font-weight: bold !important;
}

.product-store-item-name {
  max-width: 300px !important;
  overflow: scroll;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}

/* Product Search Drawer UI */
.product-search-drawer-container {
  position: absolute;
  right: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  max-width: 60vw;
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
  outline: none;
  animation: slideInRight 0.3s ease-out;
  border-radius: 1rem;
  overflow: hidden;
}
@media (max-width: 1024px) {
  .product-search-drawer-container {
    max-width: 60vw;
  }
}
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.product-search-drawer-content {
  display: flex;
  height: 100%;
  flex-direction: column;
  background: linear-gradient(180deg, #f7faff 0%, #ffffff 100%);
}

.product-search-header {
  border-bottom: 1px solid #e2e8f0;
  background-color: white;
  padding: 14px 20px;
  color: #0f172a;
}

.product-search-header-inner {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}

.product-search-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.product-search-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-search-close-btn {
  display: flex;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}
.product-search-close-btn:hover {
  background-color: #f1f5f9;
  color: #334155;
}

.product-search-input-wrapper {
  position: relative;
  flex: 1;
}

.product-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8;
  pointer-events: none;
}

.product-search-input {
  display: flex;
  width: 100%;
  height: 48px;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: white;
  padding: 4px 16px 4px 44px;
  font-size: 14px;
  color: #020617;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
  outline: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
}
.product-search-input:focus {
  box-shadow: 0 0 0 2px rgba(42, 113, 255, 0.2);
}

.product-search-header-btns {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.product-search-clear-btn {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #64748b;
  cursor: pointer;
  background: transparent;
  border: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.product-search-clear-btn:hover {
  color: #0f172a;
}

/* Add bundle button */
.product-search-bundle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  height: 36px;
  border-radius: 10px;
  border: 1.5px solid #2a71ff;
  background: #fff;
  color: #2a71ff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s, color 0.18s;
}
.product-search-bundle-btn:hover {
  background: #eff6ff;
}
.product-search-bundle-btn.active {
  background: #2a71ff;
  color: #fff;
}

.product-search-results-container {
  position: relative;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.product-search-results-inner {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 16px 20px;
  min-width: 0;
}

/* ── Scan / search hint banner (shown above top-searches grid) ── */
.ps-scan-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 12px;
  background: #f0f7ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #1d4ed8;
  flex-shrink: 0;
}
.dark .ps-scan-hint {
  background: rgba(29, 78, 216, 0.12);
  border-color: rgba(59, 130, 246, 0.3);
  color: #93c5fd;
}

.ps-left-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 160px;
  font-size: 13px;
  color: #94a3b8;
}

/* Retract sidebar when bundle builder or bundle list is active — gives full drawer width to bundle content */
.product-search-results-container.bundle-active .ss-pane {
  display: none;
}

/* When bundle builder is active, let it manage its own layout */
.product-search-results-inner.bundle-mode {
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
}

/* ── Saved bundles section ── */
.saved-bundles-section {
  margin-bottom: 18px;
}

.saved-bundles-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  color: #334155;
}

.saved-bundles-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #475569;
}

.saved-bundles-count {
  font-size: 11px;
  font-weight: 700;
  color: #2a71ff;
  background: #eff6ff;
  border-radius: 99px;
  padding: 1px 7px;
}

.saved-bundles-row {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 6px;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}
.saved-bundles-row::-webkit-scrollbar {
  height: 4px;
}
.saved-bundles-row::-webkit-scrollbar-track {
  background: transparent;
}
.saved-bundles-row::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 99px;
}

.saved-bundle-card {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 8px 10px 8px 12px;
  border-radius: 12px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
  text-align: left;
  max-width: 220px;
}
.saved-bundle-card:hover {
  border-color: #2a71ff;
  box-shadow: 0 2px 12px rgba(42, 113, 255, 0.12);
  background: #f8fbff;
}

.saved-bundle-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #eff6ff;
  color: #2a71ff;
  flex-shrink: 0;
}

.saved-bundle-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.saved-bundle-name {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}

.saved-bundle-meta {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
}

.saved-bundle-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #94a3b8;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
  cursor: pointer;
}
.saved-bundle-delete:hover {
  background: #fee2e2;
  color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/searchBar/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B;;;kDAGgD;EAChD,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,aAAa;EACb,8BAA8B;EAC9B;;sDAEoD;AACtD;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,6GAA6G;AAC7G;EACE,aAAa;AACf;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kEAAkE;EAClE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".wrapper-input-box-modal {\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  color: lightgray;\n  border-radius: 40px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  background: #fff;\n  transition: all 0.3s ease;\n}\n\n.search-container-box-modal-new {\n  flex: 1;\n}\n\n.new-search-dialog {\n  background-color: white;\n}\n\n.dark .new-search-dialog {\n  background-color: var(--dark-blue);\n}\n\n.recent-search-card {\n  margin: 5px !important;\n  border-radius: 20px !important;\n  box-shadow:\n    rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em,\n    rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em,\n    rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;\n  padding: 0.5rem;\n  width: min-content;\n  background-color: white;\n  color: black !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  border: none;\n  max-width: 300px;\n}\n\n.dark .recent-search-card {\n  background-color: var(--dark-blue);\n  color: white !important;\n}\n\n.recent-search-card:hover {\n  transform: scale(1.03);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n  background-color: #92f3c0 !important;\n  color: black !important;\n  font-weight: 1000 !important;\n}\n\n.recent-search-title {\n  font-size: 0.9rem !important;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  white-space: nowrap;\n  transition: all 0.5s ease;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: bold !important;\n}\n\n.recent-search-description {\n  font-size: 0.8rem !important;\n  font-weight: bold !important;\n}\n\n.recent-search-add {\n  background-color: #0563fb !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n.recent-search-card:focus {\n  background-color: #92f3c0 !important;\n  color: black !important;\n  border: none;\n  outline: none;\n}\n\n.recent-search-inner-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.popular-search-box {\n  height: 100vh !important;\n}\n\n.popular-search-head {\n  font-size: 1.1rem !important;\n  font-weight: bold !important;\n  text-align: left;\n  padding: 10px !important;\n  color: #0563fb;\n}\n\n.popular-search-box .MuiCardContent-root {\n  padding: 0 !important;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.products-store-code-display-box {\n  background-color: white;\n  padding: 10px;\n}\n\n.product-store-code {\n  font-size: 1rem !important;\n  font-weight: bold !important;\n  margin: 10px 0px 20px 0px !important;\n}\n\n.dark .products-store-code-display-box {\n  background-color: var(--dark-blue);\n}\n\n.product-store-card {\n  background-color: whitesmoke;\n  padding: 1rem 1rem 0rem 1rem !important;\n  display: flex;\n  justify-content: space-between;\n  box-shadow:\n    rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,\n    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px !important;\n}\n\n.dark .product-store-card {\n  background-color: rgb(26, 29, 40);\n  color: white;\n}\n\n.product-store-code-item {\n  font-size: 1rem !important;\n  font-weight: bold !important;\n}\n\n.product-store-item-name {\n  max-width: 300px !important;\n  overflow: scroll;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n}\n\n/* Product Search Drawer UI */\n.product-search-drawer-container {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  max-width: 60vw;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);\n  outline: none;\n  animation: slideInRight 0.3s ease-out;\n  border-radius: 1rem;\n  overflow: hidden;\n}\n@media (max-width: 1024px) {\n  .product-search-drawer-container {\n    max-width: 60vw;\n  }\n}\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.product-search-drawer-content {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  background: linear-gradient(180deg, #f7faff 0%, #ffffff 100%);\n}\n\n.product-search-header {\n  border-bottom: 1px solid #e2e8f0;\n  background-color: white;\n  padding: 14px 20px;\n  color: #0f172a;\n}\n\n.product-search-header-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: left;\n}\n\n.product-search-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.product-search-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.product-search-close-btn {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.product-search-close-btn:hover {\n  background-color: #f1f5f9;\n  color: #334155;\n}\n\n.product-search-input-wrapper {\n  position: relative;\n  flex: 1;\n}\n\n.product-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.product-search-input {\n  display: flex;\n  width: 100%;\n  height: 48px;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: white;\n  padding: 4px 16px 4px 44px;\n  font-size: 14px;\n  color: #020617;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n  outline: none;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n.product-search-input:focus {\n  box-shadow: 0 0 0 2px rgba(42, 113, 255, 0.2);\n}\n\n.product-search-header-btns {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.product-search-clear-btn {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #64748b;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n.product-search-clear-btn:hover {\n  color: #0f172a;\n}\n\n/* Add bundle button */\n.product-search-bundle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 14px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1.5px solid #2a71ff;\n  background: #fff;\n  color: #2a71ff;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.18s, color 0.18s;\n}\n.product-search-bundle-btn:hover {\n  background: #eff6ff;\n}\n.product-search-bundle-btn.active {\n  background: #2a71ff;\n  color: #fff;\n}\n\n.product-search-results-container {\n  position: relative;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n\n.product-search-results-inner {\n  flex: 1;\n  height: 100%;\n  overflow-y: auto;\n  padding: 16px 20px;\n  min-width: 0;\n}\n\n/* ── Scan / search hint banner (shown above top-searches grid) ── */\n.ps-scan-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  padding: 8px 12px;\n  background: #f0f7ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #1d4ed8;\n  flex-shrink: 0;\n}\n.dark .ps-scan-hint {\n  background: rgba(29, 78, 216, 0.12);\n  border-color: rgba(59, 130, 246, 0.3);\n  color: #93c5fd;\n}\n\n.ps-left-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 160px;\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n/* Retract sidebar when bundle builder or bundle list is active — gives full drawer width to bundle content */\n.product-search-results-container.bundle-active .ss-pane {\n  display: none;\n}\n\n/* When bundle builder is active, let it manage its own layout */\n.product-search-results-inner.bundle-mode {\n  overflow: hidden;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Saved bundles section ── */\n.saved-bundles-section {\n  margin-bottom: 18px;\n}\n\n.saved-bundles-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 10px;\n  color: #334155;\n}\n\n.saved-bundles-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #475569;\n}\n\n.saved-bundles-count {\n  font-size: 11px;\n  font-weight: 700;\n  color: #2a71ff;\n  background: #eff6ff;\n  border-radius: 99px;\n  padding: 1px 7px;\n}\n\n.saved-bundles-row {\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 6px;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n.saved-bundles-row::-webkit-scrollbar {\n  height: 4px;\n}\n.saved-bundles-row::-webkit-scrollbar-track {\n  background: transparent;\n}\n.saved-bundles-row::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 99px;\n}\n\n.saved-bundle-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding: 8px 10px 8px 12px;\n  border-radius: 12px;\n  border: 1.5px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;\n  text-align: left;\n  max-width: 220px;\n}\n.saved-bundle-card:hover {\n  border-color: #2a71ff;\n  box-shadow: 0 2px 12px rgba(42, 113, 255, 0.12);\n  background: #f8fbff;\n}\n\n.saved-bundle-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: #eff6ff;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n.saved-bundle-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.saved-bundle-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 130px;\n}\n\n.saved-bundle-meta {\n  font-size: 10px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.saved-bundle-delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  color: #94a3b8;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s;\n  cursor: pointer;\n}\n.saved-bundle-delete:hover {\n  background: #fee2e2;\n  color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
